var _circle, _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBombLit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 484,
    viewBox: "0 0 345 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 311.5,
    r: 172.5,
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 113,
    width: 145,
    height: 70,
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.2465,
    cy: 100.519,
    rx: 75.2465,
    ry: 100.519,
    transform: "matrix(0.964864 -0.262749 0.272107 0.962267 8.52441 244.895)",
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.2465,
    cy: 100.519,
    rx: 75.2465,
    ry: 100.519,
    transform: "matrix(0.964864 -0.262749 0.272107 0.962267 12.3015 242.438)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 36.5H191.5V111.5H153.5V36.5Z",
    fill: "#FFAE03",
    stroke: "#E28413",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.216 0L186.511 24.1587H229.534L194.728 39.0896L208.023 63.2482L173.216 48.3174L138.41 63.2482L151.705 39.0896L116.898 24.1587H159.921L173.216 0Z",
    fill: "#F45B69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.216 11.9692L181.985 27.8574L210.362 27.8574L187.405 37.6768L196.174 53.5649L173.216 43.7455L150.259 53.5649L159.028 37.6768L136.07 27.8574L164.447 27.8574L173.216 11.9692Z",
    fill: "#FFAE03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.901 19.5288L178.771 30.1934H197.765L182.398 36.7846L188.268 47.4492L172.901 40.8581L157.534 47.4492L163.404 36.7846L148.037 30.1934H167.032L172.901 19.5288Z",
    fill: "#E0E0E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombLit);
export default __webpack_public_path__ + "static/media/BombLit.0735003cf4943d63d36be13e1ce95054.svg";
export { ForwardRef as ReactComponent };